import { getUnifiedAuthConfigUrl } from './Api';
import { AuthenticateError } from './LowLevelUnifiedAuth';
export function fetchAuthConfigForUnifiedAuth(http, portalId, authenticatorId, appName, oAuthScope, mcp, appId) {
  return async () => {
    const authFlow = await http.get(getUnifiedAuthConfigUrl(authenticatorId), {
      query: {
        portalId,
        appName
      }
    });
    return {
      appName,
      appIcon: '',
      oAuthScope,
      mcp,
      authFlow,
      appId,
      getAuthorizeUrl(query) {
        return http.get(`unified-auth/v1/authenticators/${authenticatorId}/authorize-url`, {
          query: Object.assign({
            portalId
          }, query)
        });
      },
      finishAuthFlow(payload) {
        return http.post(`unified-auth/v1/authenticators/${authenticatorId}/secret`, {
          data: payload,
          query: {
            portalId
          },
          timeout: 35000
        }).then(finishPayload => {
          if (typeof finishPayload === 'object' && 'status' in finishPayload && finishPayload.status === 'error') {
            throw new AuthenticateError(finishPayload.message, finishPayload.upstreamErrorMessage);
          } else {
            return finishPayload;
          }
        });
      }
    };
  };
}